export type NotificationSettingsKeys =
  | "payrollJournalReminderSubscribed"
  | "actionRequiredEmailSubscribed"
  | "earningsReminderSubscribed";

export type EmployerNotificationsSettings = {
  actionRequiredEmailSubscribed?: boolean;
  payrollJournalReminderSubscribed?: boolean;
  earningsReminderSubscribed?: boolean;
  offCycleDisbursementApprovalSubscribed?: boolean;
};

export const initialSubscriptionState: EmployerNotificationsSettings = {
  actionRequiredEmailSubscribed: false,
  payrollJournalReminderSubscribed: false,
  earningsReminderSubscribed: false,
  offCycleDisbursementApprovalSubscribed: false,
};
